import {Separator, Actions, Action} from 'platform/components';
import {Box, Integer, Space, useDevice, VStack} from 'platform/foundation';

import {MAIN_SIDEBAR_WIDTH} from '@dms/shared';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {SETTINGS_SIDEBAR_WIDTH} from '../SettingsTemplate/SETTINGS_SIDEBAR_WIDTH';

export interface SettingsFooterProps extends TestIdProps {
  actions: Action[] | Nullish;
}

export function SettingsFooter(props: SettingsFooterProps) {
  const device = useDevice();
  const isSmallDevice = device === 'mobile' || device === 'tablet';

  const leftOffset = isSmallDevice
    ? SETTINGS_SIDEBAR_WIDTH
    : ((SETTINGS_SIDEBAR_WIDTH + MAIN_SIDEBAR_WIDTH) as Integer);
  return (
    <>
      <Space vertical={20} />
      <Box
        position="fixed"
        bottom={0}
        left={leftOffset}
        right={0}
        backgroundColor="general.white"
        zIndex="CONTENT"
      >
        <VStack>
          <Separator spacing={0} />
          <Box padding={6}>
            <Actions
              actions={props.actions}
              align="right"
              data-testid={suffixTestId('settingsFooter-wrapper', props)}
            />
          </Box>
        </VStack>
      </Box>
    </>
  );
}
